import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { Document } from '@roc/feature-types';
import { action, flow, makeObservable, observable } from 'mobx';
import { getDocumentAsBlob } from '@roc/feature-utils';
import { PostDisasterInspectionService } from '../../../services/documentForms/postDisasterInspection/postDisasterInspectionService';

const postDisasterInspectionForm = {
  fields: {
    femaIncidentEndDate: {
      type: 'DATE',
      value: null,
      error: null,
      rule: 'required',
      format: 'MM/dd/yyyy',
      message: 'This field is required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class PostDisasterInspectionFormStore extends FormStore {

  postDisasterInspectionFile: File;
  document: Document;
  propertyInfo: any;

  globalStore: GlobalStore;
  postDisasterInspectionService: PostDisasterInspectionService;

  constructor(globalStore) {
    super({ ...postDisasterInspectionForm }, globalStore);

    this.globalStore = globalStore;
    this.postDisasterInspectionService = new PostDisasterInspectionService();

    makeObservable(this, {
      postDisasterInspectionFile: observable,
      setPostDisasterInspectionFile: action,
      getFemaPropertyInfo: flow,
      changeFemaDocumentsStatus: flow,
    });
    this.setDefaults();
  }

  private setDefaults() {
    this.setPostDisasterInspectionFile(null);
    this.propertyInfo = {};
  }

  reset() {
    super.reset();
    this.setDefaults();
  }

  setPostDisasterInspectionFile(file: File) {
    this.postDisasterInspectionFile = file;
  }

  *getFemaPropertyInfo(loan, document, downloadExistingFile) {
    try {

      this.reset();
      this.document = document;

      if (downloadExistingFile) {
        const response = yield downloadExistingFile(document);

        // Decode Base64 string to binary
        const base64String = response.data?.data?.docBytesArray;
        const binaryString = atob(base64String);
        const fileName = response.data?.data?.originalFileName || document.originalFileName || document.taskName;

        // Convert binary string to Uint8Array
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        // Create a Blob from the byte array
        const blob = new Blob([bytes], { type: response.data?.data?.contentType || 'application/octet-stream' });

        // Create a File object (multipart file)
        const file = new File([blob], fileName, {
          type: response.data?.data?.contentType || 'application/octet-stream'
        });

        this.postDisasterInspectionFile = file;
      }

      const response = yield this.postDisasterInspectionService.getFemaPropertyInfo(loan?.loanId, this.document?.loanTaskId);
      if (response?.data?.propertyId) {
        this.propertyInfo = response?.data;
      }
      else {
        this.propertyInfo = {
          loanId: loan?.loanId,
          documentId: this.document?.loanTaskId,
        };
      }
      this.loadForm(this.propertyInfo);
    }
    catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error while trying to get the details for this property fema disaster.',
      });
    }
  }

  *changeFemaDocumentsStatus(onClose) {
    try {
      this.runFormValidationWithMessage();
      if (this.form.meta.isValid) {
        yield this.postDisasterInspectionService.changeFemaDocumentsStatus(this.document?.loanId, this.document?.collateralId);
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Fema Documents accepted.',
        });
        onClose();
      }
    } catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error while trying to update the status of the document.',
      });
    }
  }

}